(function initPuzzleRenderer() {
  const imageUrlPrefix = 'https://res.cloudinary.com/da9yd4bgx/image/fetch/t_puzzle-v1/';

  function renderPuzzleOffer({ petName, submissionImageUrl } = {}) {
    const mediaGallery = document.querySelector('.main-product__media-gallery');
    const titleElement = document.querySelector('.main-product__blocks h1');
    const imageElement =
      document.querySelector('.rte.caption img') ||
      document.querySelector('.main-product__media-gallery img') ||
      document.createElement('img');

    if (!mediaGallery) {
      return () => { };
    }

    mediaGallery.style.textAlign = 'center';
    mediaGallery.innerHTML = '<div class="loader"></div>';

    if (petName && titleElement) {
      titleElement.innerHTML = `300pc Jigsaw Puzzle<br> ft. ${petName}`;
    }

    if (submissionImageUrl) {
      const puzzleImageUrl = `${imageUrlPrefix}${encodeURIComponent(submissionImageUrl)}`;
      imageElement.src = puzzleImageUrl;
      imageElement.setAttribute('srcset', puzzleImageUrl);
    }

    mediaGallery.innerHTML = '';
    mediaGallery.append(imageElement);

    return () => { };
  }

  window.renderPuzzleOffer = renderPuzzleOffer;
})();
